import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { QuestionCheckboxComponent } from './question-checkbox.component';
import { DndModule } from 'ngx-drag-drop';
import { OptionNumberModule, OptionTextModule } from '../../options';

@NgModule({
  imports: [
    QuestionModule,
    DndModule,
    OptionNumberModule, OptionTextModule,
  ],
  declarations:[QuestionCheckboxComponent],
  exports:[QuestionCheckboxComponent],
})
export class QuestionCheckboxModule { }

